import React from 'react';
import { Box, useTheme } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';

const IninerarySectionSkeleton = (props) => {
  const { itemsLength = 2 } = props;
  const theme = useTheme();
  return (
    <Box sx={{ position: 'relative' }} my={3}>
      {/* Timeline vertical line */}
      <Box
        sx={{
          position: 'absolute',
          left: 29,
          top: 0,
          bottom: 0,
          width: '2px',
        }}
      />

      {[...Array(itemsLength).keys()].map((item) => (
        <Box key={item} sx={{ position: 'relative' }}>
          <Box
            sx={{
              p: 3,
              borderLeft: '2px solid',
              borderColor: theme.palette.common.black,
              borderRadius: 1,
            }}>
            {/* Content */}
            <Box>
              <Skeleton variant="rounded" width="80%" height={382} />
              <Skeleton variant="text" width="100px" height={30} />
              <Skeleton variant="text" width="300px" height={50} />
              <Skeleton variant="text" width="150px" height={30} />
              <Skeleton variant="text" width="80%" height={161} />
            </Box>
          </Box>

          {/* Timeline dot */}
          <Box
            sx={{
              position: 'absolute',
              left: -10,
              top: 20,
              width: 20,
              height: 20,
              borderRadius: '50%',
              bgcolor: theme.palette.common.black,
              border: `2px solid ${theme.palette.background.primary}`,
            }}
          />
        </Box>
      ))}
    </Box>
  );
};

export { IninerarySectionSkeleton };
